import React, { ComponentProps } from 'react';
import { MigrationModalManager } from '@fiverr-private/pro_migration';

type Props = ComponentProps<typeof MigrationModalManager>;

const FipMigrationModalManager = (props: Props) => <MigrationModalManager {...props} />;

export default FipMigrationModalManager;
